import styled, { css } from 'styled-components'

export const Button = styled.button<{ variant?: 'full-width' | 'contained' }>`
  display: block;
  width: 100%;
  ${({ variant }) =>
    variant === 'contained'
      ? css`
          max-width: 330px;
        `
      : ''};
  background-color: ${({ theme }) => theme.colors.brand.blue};
  font-family: ${({ theme }) => theme.fonts.component.button};
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.06em;
  text-align: center;
  color: ${({ theme }) => theme.colors.coolGray.cool100};
  padding: 17px 22.5px;
  border: 0;
  border-radius: 4px;
  cursor: pointer;
  margin: 20px auto;
  text-transform: uppercase;
  &:disabled,
  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`
